import configService from './config.service';

const getOfficesByCountryCity = async (country, city) => {
    const payLoad = {
        country: !country || country === 'All' ? '' : country,
        city: !city || city === 'All' ? '' : city
    };

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payLoad)
    };

    const response = await fetch(`${configService.appConfig.baseApiEndpoint}/External/Office/Search`, options);

    if (!response.ok) {
        const message = `An error occurred: ${response.statusText}`;
        console.error(message);
        return;
    }

    const jsonData = await response.json();
    return jsonData;
};

const getAllCountry = async () => {
    const options = {
        method: 'GET'
    };

    const response = await fetch(`${configService.appConfig.baseApiEndpoint}/External/Office/Country/All`, options);

    if (!response.ok) {
        const message = `An error occurred: ${response.statusText}`;
        console.error(message);
        return;
    }

    const jsonData = await response.json();
    return jsonData;
};

const getAllCityByCountry = async (country) => {
    const options = {
        method: 'GET'
    };

    const response = await fetch(`${configService.appConfig.baseApiEndpoint}/External/Office/City/Country/${country}`, options);

    if (!response.ok) {
        const message = `An error occurred: ${response.statusText}`;
        console.error(message);
        return;
    }

    const jsonData = await response.json();
    return jsonData;
};

export default {
    getOfficesByCountryCity,
    getAllCountry,
    getAllCityByCountry
};
